// extracted by mini-css-extract-plugin
export default {"input":"N--z","button":"O--z","selected":"P--z","unavailable":"Q--z","oos":"R--z","image":"S--z","paperCutDisabledOverlay":"T--z"};